import { Link } from 'react-router-dom';
import './Footer.css';
import logo2 from '../../assets/logo2.png';

const Footer = () => {
    return (
        <footer className="site-footer">

            <div className="footer-top">

                {/* BRAND */}
                <div className="footer-brand">
                    <div className="footer-logo">
                        <img src={logo2} alt="Logo" />
                    </div>

                    <p>
                        Jeevan Realty is a one-stop online real estate agency in Coimbatore,
                        dedicated to helping you find the perfect property. Our comprehensive repository of
                        property data and detailed information empowers you to make informed decisions and
                        invest confidently in assets that match your goals.
                    </p>
                </div>

                {/* COMPANY */}
                <div className="footer-column">
                    <h4>Company</h4>
                    <ul>
                        <li><Link to="/about">About Us</Link></li>
                        <li><Link to="/contact">Contact Us</Link></li>
                        <li><a href="#">Our Reviews</a></li>
                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                        <li><Link to="/terms-conditions">Terms and Conditions</Link></li>
                    </ul>
                </div>

                {/* WHAT WE DO */}
                <div className="footer-column">
                    <h4>What We Do</h4>
                    <ul>
                        <li><Link to="/buy-sell-properties">Buy & Sell Properties</Link></li>
                        <li><Link to="/property-management">Property Management</Link></li>
                        <li><Link to="/marketing-management">Marketing & Management</Link></li>
                        <li><Link to="/real-estate-investment">Real Estate Investment</Link></li>
                        <li><Link to="/construction-development">Construction & Development</Link></li>
                    </ul>
                </div>

                {/* CATEGORIES */}
                <div className="footer-column">
                    <h4>Categories</h4>
                    <ul>
                        <li><Link to="/agricultural-lands">Agriculture Lands</Link></li>
                        <li><Link to="/apartments">Apartments</Link></li>
                        <li><Link to="/commercial-plots">Commercial Plots</Link></li>
                        <li><Link to="/residential-plots">Residential Plots</Link></li>
                        <li><Link to="/villas">Villas</Link></li>
                    </ul>
                </div>

            </div>

            {/* FOOTER BOTTOM */}
            <div className="footer-bottom">
                <p>© Jeevan Realty 2025, All Rights Reserved.
                    Concept by {<a href="https://jeevantech.in/services/web-development-services/">JeevanTech</a>}</p>
            </div>

        </footer>
    );
};

export default Footer;
